import React, { useState, useEffect } from 'react';
import logo from '../assets/images/logo.png';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`nav ${scrolled ? 'pinned' : 'top'}`}>
      <div className="wrap nav-inner">
        {/* Logo */}
        <a href="#home" className="logo">
          <div className="logo-mark">
            <img src={logo} alt="PictureIt Logo" />
          </div>
          <span className="logo-text">PictureIt</span>
        </a>

        {/* Nav links */}
        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <li>
            <a href="#features" onClick={closeMenu}>
              Features
            </a>
          </li>
          <li>
            <a href="#how" onClick={closeMenu}>
              How It Works
            </a>
          </li>
          <li>
            <a href="#platforms" onClick={closeMenu}>
              Download
            </a>
          </li>
          <li>
            <a href="#platforms" className="nav-btn" onClick={closeMenu}>
              Get the App
            </a>
          </li>
        </ul>

        {/* Mobile hamburger */}
        <button
          className="burger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
}

export default Navbar;